module.exports = __webpack_public_path__ + "fonts/NeutraTextTF-Bold.4eca28aad0977687b0b9de087a020e55.otf";